import { LockersContextProvider } from './LockersContext';
import { ClientContextProvider } from './ClientContext';
import { AccordionContextProvider } from './AccordionContext';
import { FiltersContextProvider } from './FiltersContext';
import { SpecificLockerActionContextProvider } from './SpecificLockerActionContext';
import { TrackingContextProvider } from './TrackingContext';
import { LoadingContextProvider } from './LoadingContext';
import { RecaptchaContextProvider } from './RecaptchaContext';
import { ContextProviderProps } from "../common/contextFactory";

function AppContext({ children }: ContextProviderProps) {

    return (
        <LockersContextProvider>
            <ClientContextProvider>
                <SpecificLockerActionContextProvider>
                    <AccordionContextProvider>
                        <TrackingContextProvider>
                            <FiltersContextProvider>
                                <RecaptchaContextProvider>
                                    <LoadingContextProvider>
                                        {children}
                                    </LoadingContextProvider>
                                </RecaptchaContextProvider>
                            </FiltersContextProvider>
                        </TrackingContextProvider>
                    </AccordionContextProvider>
                </SpecificLockerActionContextProvider>
            </ClientContextProvider>
        </LockersContextProvider>
    );
}

export default AppContext;
